import React from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { PageTitleModel } from "./models/PageTitle.model";
import { PageTitleProps } from "./types/PageTitle.types";
import LazySection from "../../react-only-components/LazySection";

const PageTitle = (props: PageTitleProps) => {
  const model = new PageTitleModel(props);
  return (
    <LazySection>
      {props?.fields && (
        <div className="privacy-page-title">
          <img hidden className="print-logo" src="http://cnhi001.westeurope.cloudapp.azure.com/cnhicorporate/-/jssmedia/Basic/CNHi/Content/Navigation/Logo_CNH_Industrialsvg.svg?iar=0&rev=-1&hash=73AAB3F32EEFF95CA84733EC23FBA41F" />
          {model?.title?.value}
        </div>
      )}
    </LazySection>
  );
};

export default withSitecoreContext()(PageTitle);
